// extracted by mini-css-extract-plugin
module.exports = {"shimmer":"Shimmer_shimmer__0vm3J","base":"Shimmer_base__AVTdO","pulse":"Shimmer_pulse__ah_jp","circle":"Shimmer_circle__IrQz_"};